import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45703d82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "clients-tabs bg-white radius-7 mb-20" }
const _hoisted_2 = {
  class: "clients-tabs__list",
  role: "tablist",
  "aria-label": "Clientes"
}
const _hoisted_3 = ["aria-selected", "title", "onClick"]
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-xxl-12" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { key: 4 }
const _hoisted_11 = { key: 5 }
const _hoisted_12 = { key: 6 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClientsList = _resolveComponent("ClientsList")!
  const _component_ClientsRankingQtdAttendant = _resolveComponent("ClientsRankingQtdAttendant")!
  const _component_ClientsRankingTotalValue = _resolveComponent("ClientsRankingTotalValue")!
  const _component_ClientsRankingLastAttendant = _resolveComponent("ClientsRankingLastAttendant")!
  const _component_ClientsRankingTotalValueSold = _resolveComponent("ClientsRankingTotalValueSold")!
  const _component_ClientsRankingLastPurchase = _resolveComponent("ClientsRankingLastPurchase")!
  const _component_ClientsBirthdayMonth = _resolveComponent("ClientsBirthdayMonth")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
          return (_openBlock(), _createElementBlock("button", {
            key: tab.key,
            type: "button",
            class: _normalizeClass(["clients-tabs__button", { active: _ctx.currentTab === tab.key }]),
            role: "tab",
            "aria-selected": _ctx.currentTab === tab.key,
            title: tab.title,
            onClick: ($event: any) => (_ctx.openTab(tab.key))
          }, [
            _createElementVNode("span", null, _toDisplayString(tab.label), 1)
          ], 10, _hoisted_3))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_ctx.currentTab === 'TC')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_ClientsList)
            ]))
          : _createCommentVNode("", true),
        (_ctx.currentTab === 'QA')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_ClientsRankingQtdAttendant)
            ]))
          : _createCommentVNode("", true),
        (_ctx.currentTab === 'VGA')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_ClientsRankingTotalValue)
            ]))
          : _createCommentVNode("", true),
        (_ctx.currentTab === 'AMA')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_ClientsRankingLastAttendant)
            ]))
          : _createCommentVNode("", true),
        (_ctx.currentTab === 'VGC')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_ClientsRankingTotalValueSold)
            ]))
          : _createCommentVNode("", true),
        (_ctx.currentTab === 'VMA')
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_ClientsRankingLastPurchase)
            ]))
          : _createCommentVNode("", true),
        (_ctx.currentTab === 'AM')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_ClientsBirthdayMonth)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}